import { ReferralToSpecialistCreateOrUpdateDetails } from '@dreryk/egabinet-referral-frontend-api';

import { Choice } from '@dreryk/watermelon';

import { createReferralDiagnosesPayload } from '../../shared/common.utils';
import { ReferralToSpecialistFormBean } from '../ReferralToSpecialistForm/ReferralToSpecialistForm.types';

export const mapReferralToSpecialistFormBeanToReferralCommandDetails = (
   formData: ReferralToSpecialistFormBean,
   electronic?: boolean
): ReferralToSpecialistCreateOrUpdateDetails => {
   return {
      cito: formData.cito ?? false,
      // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion
      medicalClinicCode: Choice.withUseDefaultIfNull(formData.healthcareFacilityLocationSpecialty?.code ?? null),
      unitNameAndAddress: Choice.withUseDefaultIfNull(formData.unitNameAndAddress ?? null),
      diagnoses: createReferralDiagnosesPayload(formData.diagnoses.value),
      objective: Choice.withUseDefaultIfNull(formData.objective ?? null),
      preexistingDiseases: Choice.withUseDefaultIfNull(formData.illnessesAlreadyPassed ?? null),
      examinationsPerformed: Choice.withUseDefaultIfNull(formData.examinationsAlreadyPerformed ?? null),
      additionalInformation: Choice.withUseDefaultIfNull(formData.additionalInformation ?? null),
      electronic: electronic ?? false,
      icd9ProceduresCodes: formData.icd9Procedures.map(({ code }) => code),
   };
};
